var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Avatar',{attrs:{"avatar_url":_vm.avatar_url,"name":_vm.name,"name_symbol":_vm.name_symbol,"updateResource":_vm.uploadAvatar,"classes":"-reverse -large"}})
}
var staticRenderFns = []

export { render, staticRenderFns }